import Axios from "axios";

const kblClient = Axios.create();

kblClient.defaults.baseURL = "https://cms-api.kbl.or.kr/";
kblClient.defaults.headers.common["App-Agent"] =
  "platformCode=70;platformVer=5.0.1;deviceId=ASD12345KFOKFIKL;appName=wizzapWeb;appVer=10.0.0;deviceModel=Browser;";
kblClient.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

kblClient.interceptors.request.use(
  function (config) {
    const user = sessionStorage.getItem("sessionUser");
    if (user != null && user !== "null") {
      config.headers["Access-Token"] = JSON.parse(user).tid;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default kblClient;
